import '../index.css';

export default function Comparison() {
  return (
    <section className="comparison-section">
      <div className="section-inner">
        <p className="section-label">⚔️ COMPARAÇÃO DEFINITIVA</p>
        <h2 className="section-title">Original vs. Cópias Piratas</h2>
        <p className="section-subtitle">Entenda por que a original é a única que vale a pena</p>

        <div className="comparison-wrapper">
          <table className="comparison-table">
            <thead>
              <tr>
                <th></th>
                <th className="col-original">
                  <div className="th-content">
                    <span className="th-badge">👑 ORIGINAL</span>
                    <span className="th-name">Mestre Lovable Infinity</span>
                  </div>
                </th>
                <th className="col-fake">
                  <div className="th-content">
                    <span className="th-badge">⚠️ CÓPIAS</span>
                    <span className="th-name">Cópias Baratas</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="row-label">Funciona?</td>
                <td className="check"><span className="badge-check">✓ 100% Funcional</span></td>
                <td className="cross"><span className="badge-cross">✕ Todas outras quebradas</span></td>
              </tr>

              <tr>
                <td className="row-label">Suporte</td>
                <td className="check"><span className="badge-check">✓ WhatsApp dedicado</span></td>
                <td className="cross"><span className="badge-cross">✕ Nenhum</span></td>
              </tr>
              <tr>
                <td className="row-label">Segurança</td>
                <td className="check"><span className="badge-check">✓ Sem risco de ban</span></td>
                <td className="warn"><span className="badge-warn">⚠️ Risco de ban</span></td>
              </tr>
              <tr>
                <td className="row-label">Funcionalidades</td>
                <td className="check"><span className="badge-check">✓ Chat, melhorador de prompt, anexar, remover marca dágua</span></td>
                <td className="cross"><span className="badge-cross">✕ Básico e bugado</span></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="comparison-alert bg-[#DC2626]">
          <span className="alert-icon">⚠️</span>
          <p className="text-[#000000]"><strong className="text-[#000000]">ALERTA:</strong> Versões piratas estão causando ban de contas. Não arrisque!</p>
        </div>
      </div>
    </section>);

}